<template>
  <TeacherSchedule />
</template>

<script>
import TeacherSchedule from "../../../components/TeacherSchedule.vue";
export default { name: "schedule-list", components: { TeacherSchedule } };
</script>
